import { memo, useCallback, useMemo } from 'react';

import { PasscodeProtectionRow } from '~/components/ShareModal/components/SecurityPrivacySection/PasscodeProtectionRow';
import { useShowcaseModal } from '~/components/ShowcaseModal/ShowcaseModalContext';
import { buildDraftShortIdInfo } from '~/components/ShowcaseModal/utils';

/** Create-mode smart leaf: passcode protection row driven by a synthetic draft `shortIdInfo`. */
export const CreateShowcaseSettingsPasscodeRow = memo(() => {
  const { shortUrlProps, updatePasscode } = useShowcaseModal();

  const draftShortIdInfo = useMemo(
    () =>
      buildDraftShortIdInfo(
        shortUrlProps.passcode,
        shortUrlProps.disabled,
        shortUrlProps.expirationDate,
        shortUrlProps.permissions,
        shortUrlProps.presentationSettings,
      ),
    [
      shortUrlProps.passcode,
      shortUrlProps.disabled,
      shortUrlProps.expirationDate,
      shortUrlProps.permissions,
      shortUrlProps.presentationSettings,
    ],
  );

  const handleChangePasscode = useCallback(
    async (passcode: string | null) => {
      updatePasscode(passcode);
    },
    [updatePasscode],
  );

  return (
    <PasscodeProtectionRow shortIdInfo={draftShortIdInfo} onChangePasscode={handleChangePasscode} hideSaveButton />
  );
});

CreateShowcaseSettingsPasscodeRow.displayName = 'CreateShowcaseSettingsPasscodeRow';
